import { Shard } from '@/components/art/shard';

const principles = [
  {
    title: 'Direct contact with the person building',
    body: 'No account managers and no handoffs. The point of contact is the architect, the strategist, and the builder in one seat.',
  },
  {
    title: 'Inside the team and its workflow',
    body: '7Sigma works in the client’s repos, follows the client’s process, and fills the technical gaps that matter.',
  },
  {
    title: 'Every decision serves business, product, and system goals',
    body: 'Architecture shaped by customer needs, operating reality, compliance posture, and outcomes.',
  },
  {
    title: 'Fast now, durable later',
    body: 'Quick iterations on clean code and solid foundations. Speed today, stability tomorrow.',
  },
  {
    title: 'Context that carries across domains',
    body: 'From trading engines to tax workflows, from LLM agents to access control: patterns and perspective that hold up under pressure.',
  },
];

export function SevenSigmaDifference() {
  return (
    <section className="py-12 md:py-20 relative isolate overflow-hidden">
      <Shard side="right" variant="mesh" strength={0.9} />
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-[1.75rem] md:text-4xl font-bold text-white mb-3">How 7Sigma works</h2>
        <p className="text-white/60 max-w-2xl mb-10 leading-relaxed">
          Most technical problems are business problems in disguise, and most builds die in the
          meeting before the first commit. 7Sigma connects strategy, product, and architecture and
          makes the decisions in real time.
        </p>
        <div className="divide-y divide-white/10 border-y border-white/10">
          {principles.map((p, i) => (
            <div
              key={p.title}
              className="py-5 md:py-7 flex gap-3 md:grid md:grid-cols-[3rem_1fr] md:gap-6"
            >
              <div className="text-sm md:text-2xl font-semibold text-white/45 md:text-white/35 tabular-nums pt-1 md:pt-0 w-6 md:w-auto flex-shrink-0">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white">{p.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed mt-2 max-w-2xl">{p.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
